var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [_c('v-card', {
    staticClass: "overflow-auto",
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("eBook 열람")])]), _c('div', [_c('v-data-table', {
    staticClass: "v-data-table--sm purchase-table",
    attrs: {
      "items": _vm.ebooks,
      "headers": _vm.ebookHeaders,
      "disable-pagination": "",
      "disable-sort": "",
      "mobile-breakpoint": "768",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.ebook",
      fn: function fn(_ref) {
        var _item$product, _item$product2;

        var item = _ref.item;
        return [_c('div', {
          staticClass: "px-8px py-12px px-md-10px py-md-16px"
        }, [_c('v-row', {
          staticClass: "row--small",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('div', {
          staticClass: "pr-10px"
        }, [_c('v-img', {
          staticClass: "border",
          attrs: {
            "src": item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.thumb,
            "width": "120",
            "aspect-ratio": 1 / 1,
            "contain": ""
          }
        })], 1)]), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('p', {
          staticClass: "font-size-16 font-weight-medium text-truncate"
        }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.name))])])], 1)], 1)];
      }
    }, {
      key: "item.open",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [!['반품요청', '반품완료'].includes(item.status) ? _c('v-btn', {
          staticClass: "white--text px-6px",
          attrs: {
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.open(item);
            }
          }
        }, [_vm._v("보기")]) : _vm._e()];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }